/* eslint-disable no-else-return */
/* eslint-disable no-useless-return */
/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addUserID } from '~/store/modules/User/actions';
import { Container } from '~/styles/pagesStyle';
import { handleDeleteUser, handleUpdate } from '../UserServices';
import UpdateUserCard from './UpdateUserCard';

const initialForm = {};

function UserUpdate() {
  const history = useHistory();
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [form, setForm] = useState(initialForm);
  const usuarioLogado = sessionStorage.getItem('@auth/userName');
  const dataInclusao = new Date().toISOString();
  const dataExpiracaoSenha = new Date().toISOString();

  useEffect(() => {
    api
      .get(`Usuario/${id}`)
      .then((response) => {
        dispatch(addUserID(id));
        setUserData(response.data);
      })
      .catch(() => toast.error('Erro ao carregar dados do usuário'));
  }, [id]);

  async function handleUpdateUser(event) {
    const userUpdate = {
      id: parseInt(id),
      idPessoaEmpresa: userData.idPessoaEmpresa,
      idPessoa: userData.idPessoaEmpresa,
      login: form.user || userData.login,
      senha: userData.senha,
      dataExpiracaoSenha,
      acessoRestrito: true,
      email: form.email || userData.email,
      dataInclusao,
      usuario: usuarioLogado,
      excluido: false,
    };
    event.preventDefault();
    setLoading(true);
    await handleUpdate(event, setLoading, userUpdate);
    setLoading(false);
    history.push('/user/list');
  }

  async function handleDelete() {
    await handleDeleteUser(setLoading);
    setTimeout(history.push('/user/list'), 3000);
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(userData).length <= 0 ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '20% 45% 0 0' }}
        />
      ) : (
        <UpdateUserCard
          userData={userData}
          setForm={setForm}
          form={form}
          handleDelete={handleDelete}
          handleUpdateUser={handleUpdateUser}
          loading={loading}
        />
      )}
    </Container>
  );
}

export default UserUpdate;
